import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApplicationState, Slices } from '../types.ts';

export type NotificationsState = {
  count: number;
};

const initialState: NotificationsState = {
  count: 0
};

export const notificationsSlice = createSlice({
  name: Slices.NOTIFICATIONS,
  initialState,
  reducers: {
    setCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    }
  }
});

export const notificationsActions = {
  ...notificationsSlice.actions
};

const selectCount = (state: ApplicationState) => state.notifications.count;

export const notificationsSelectors = {
  selectCount
};

export default notificationsSlice.reducer;
